// PREFILL BASE CLASSES.
document.addEventListener('DOMContentLoaded', () => {
    if (!window.matchMedia('(min-width: 992px)').matches) {
        document.querySelector('body').classList.add('is-mobile')
    } else {
        document.querySelector('body').classList.add('is-desktop')
    }
})
